import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Container } from '@src/components/Container';
import FrBinocularSvg from '@src/svgs/fr-binocular.svg';
import FrApprovedSvg from '@src/svgs/fr-approved.svg';
import PositiveLineSvg from '@src/svgs/positive-line.svg';
import { numberWithCommas } from '@src/util/numberWithCommas';
import { Props } from './props';
import './styles.scss';

export const Statistics: FC<Props> = ({ applicantsCount, offerViews, isLoading }) => {
  return (
    <div className="talent-statistics">
      <Container className="talent-statistics__card" type="bordered">
        <div className="talent-statistics__left">
          <Svg className="talent-statistics__icon" src={FrBinocularSvg} />
          <div className="talent-statistics__stats">
            <h3>Offer views</h3>
            <span>
              {isLoading ? (
                <span className="talent-statistics__stat-loading pulse-fade" />
              ) : (
                numberWithCommas(offerViews)
              )}
            </span>
          </div>
        </div>
        <Svg className="talent-statistics__stat-icon" src={PositiveLineSvg} />
      </Container>
      <Container className="talent-statistics__card" type="bordered">
        <div className="talent-statistics__left">
          <Svg className="talent-statistics__icon" src={FrApprovedSvg} />
          <div className="talent-statistics__stats">
            <h3>Applicants</h3>
            <span>
              {isLoading ? (
                <span className="talent-statistics__stat-loading pulse-fade" />
              ) : (
                numberWithCommas(applicantsCount)
              )}
            </span>
          </div>
        </div>
        <Svg className="talent-statistics__stat-icon" src={PositiveLineSvg} />
      </Container>
    </div>
  );
};
